import React from 'react'
import {translate} from 'react-i18next'
import Helmet from 'react-helmet'
import Header from '../components/Header.js'
import image from '../images/product.jpg'

const Product = translate('product')(
  ({t}) => (
    <div id="product">
      <Header current="product" />
      <div className="container">
        <div className="col4 col-pad1">
          <section>
            <h1>Historie</h1>
            <h2>Decentralized social discussion platform</h2>
            <div className="product-image">
              <img src={image} />
            </div>
            <div className="product-caption">
              {t('d1')}
            </div>
          </section>
        </div>
      </div>
    </div>
  )
)

export default () => (
  <div>
    <Helmet
      meta={[
        {name: 'description', content: 'Babels Product'},
        {property: 'og:title', content: 'Babels Product'},
        {property: 'og:url', content: 'https://babels.co/product'},
        {property: 'og:image', content: 'https://dummyimage.com/600x400/000/fff'},
        {property: 'og:image:width', content: '600'},
        {property: 'og:image:height', content: '400'},
        {property: 'og:description', content: 'Babels Product'},
        {name: 'twitter:card', content: 'summary_large_image'},
        {name: 'twitter:site', content: '@null'},
        {name: 'twitter:creator', content: '@null'}
      ]}
    />
    <Product />
  </div>
)



// WEBPACK FOOTER //
// ./src/pages/product.js